/* eslint-disable */
export const UPDATE_MEDIA_LIBRARY = 'UPDATE_MEDIA_LIBRARY'
export const CHANGE_PAGE = 'CHANGE_PAGE'
/* eslint-enable */
